import classNames from 'classnames'
import { bool, node, oneOf, string } from 'prop-types'

import { TOOLTIP_SIDES, TOOLTIP_TYPES } from 'shared/consts/tooltip'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'

import './Tooltip.scss'

const getToolTipPosition = condition => (condition ? 'relative' : 'absolute')

const Tooltip = ({
  text,
  id,
  isVisible,
  isOnlyVisibleInView,
  fullWidth,
  children,
  icon,
  type,
  sideRendered,
  noFullWidthMobile,
  isDismissble,
}) => {
  const containerClassName = classNames('m-Tooltip', {
    [`m-Tooltip--${sideRendered}`]: sideRendered,
    [`m-Tooltip-position-${getToolTipPosition(!!children)}`]: true,
    [`m-Tooltip--${type}`]: true,
    'm-Tooltip--full-width': fullWidth,
    'm-Tooltip--no-full-width-mobile': noFullWidthMobile,
  })

  const toolTipClassName = classNames('m-Tooltip__text', {
    'm-Tooltip--visible-in-view': isOnlyVisibleInView,
  })

  // when `isOnlyVisibleInView` is `false`, only then check `isVisible`
  const hidden = !isOnlyVisibleInView && isVisible ? null : true

  const renderedIcon = icon ? (
    <ButtonAsLink
      type="button"
      inheritColor
      aria-controls={id}
      data-clientside-hook="tooltip__button"
    >
      {icon}
    </ButtonAsLink>
  ) : null

  return (
    <span className={containerClassName} data-tooltip-text={text}>
      <div
        className={toolTipClassName}
        role="tooltip"
        id={id}
        aria-hidden={hidden}
        data-dissmissble={isDismissble}
        data-clientside-hook={id}
      >
        <div>{text}</div>
        {renderedIcon}
      </div>
      {children}
    </span>
  )
}

Tooltip.propTypes = {
  text: string.isRequired,
  sideRendered: oneOf(Object.values(TOOLTIP_SIDES)),
  id: string.isRequired,
  isVisible: bool,
  icon: node,
  fullWidth: bool,
  noFullWidthMobile: bool,
  type: oneOf(Object.values(TOOLTIP_TYPES)),
  children: node,
  isOnlyVisibleInView: bool,
  isDismissble: bool,
}

Tooltip.defaultProps = {
  isVisible: false,
  isOnlyVisibleInView: false,
  fullWidth: true,
  children: null,
  type: TOOLTIP_TYPES.DEFAULT,
  noFullWidthMobile: false,
  sideRendered: TOOLTIP_SIDES.TOP,
}

export default Tooltip
